"use client";
import HomeContent from "containers/HomeContainer/HomeContent";
import { usePullToRefresh } from "hooks/usePullToRefresh";

export default function Home() {
  // Example: Add pull-to-refresh functionality
  usePullToRefresh({
    onRefresh: async () => {
      // Custom refresh logic for home page
      // For now, just reload the page
      await new Promise(resolve => setTimeout(resolve, 1000));
      window.location.reload();
    }
  });

  return <HomeContent />;
}
